export const COMPOSER_TEXTAREA_MIN_HEIGHT_VAR = "--chat-composer-textarea-min-height";
export const COMPOSER_TEXTAREA_MAX_HEIGHT_VAR = "--chat-composer-textarea-max-height";
